<template>
  <div v-if="section">
    <hr noshade>
    <div>
      <div v-if="isEditMode">
        <b-tabs pills class="b-tabs-subsections">
          <template v-slot:tabs-end>
            <draggable
              :list="section.subSections"
              filter="#plusButton"
              @change="onSubsectionMove()"
              >
              <b-nav-item
                v-for="(subsection, index) in section.subSections" :key="subsection.id"
                :class="getClasses(subsection.id, checkIsPassedSubsection(subsection.id))"
                :style="getStyle(index)"
                >
                <em :class="getIconClass(subsection)" />
              </b-nav-item>
              <b-nav-item
                @click="onAddSubSection"
                :class="plusClasses"
                id="plusButton"
                >
                <em class="fas fa-lg fa-plus" />
              </b-nav-item>
            </draggable>
          </template>
        </b-tabs>
      </div>
      <div v-else>
        <b-tabs pills class="b-tabs-subsections">
          <template v-slot:tabs-end>
            <b-nav-item
              :disabled="!isNavigationEnabled"
              :class="getClasses(subsection.id, checkIsPassedSubsection(subsection.id))"
              v-for="subsection in section.subSections" :key="subsection.id"
              @click="goToOtherSubsection(subsection.id)"
              :title="getTooltip(subsection)"
              >
                <em :class="getIconClass(subsection)" />
            </b-nav-item>
          </template>
        </b-tabs>

      </div>
    </div>
    <hr noshade >
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import draggable from 'vuedraggable'
import RouteMixin from '@/components/helpers/mixins/route-mixin'

export default {
  name: 'CourseBookSubsectionsList',
  components: {
    draggable
  },
  data() {
    return {
      currentTab: 0,
      plusClasses: {
        'm-1': true,
        'b-tabs-subsections__li': true,
        'b-tabs-subsections__li-not-passed': true
      }
    }
  },
  mixins: [RouteMixin],
  props: {
    isNavigationEnabled: {
      type: Boolean,
      default() {
        return false
      }
    },
    isEditMode: {
      type: Boolean,
      default: false
    },
    onAddSubSection: {
      type: Function,
      default() {
        throw new Error('Добавь onAddSubsection в CourseBookSubsectionsList')
      }
    }
  },
  computed: {
    ...mapGetters({
      courseContent: 'education/getCourseContent',
      testContent: 'education/getTestContent',
      updater: 'contentManager/getUpdater',
      isTestCreationMode: 'test/isTestCreationMode',
      isTestViewMode: 'test/isTestViewMode',
      editedTestId: 'test/getEditedTestId',
      isTestingMode: 'test/isTestingMode',
      solvedTasks: 'test/getSolvedTasks',
      isTestReviewMode: 'educationStudentsManagement/getTestReviewMode',
      solvedByStudent: 'educationStudentsManagement/getSolvedByStudent',
      test: 'test/getTest'
    }),
    content() {
      return (this.isTestCreationMode && !this.isTestViewMode)
        ? this.testContent : this.courseContent
    },
    selectedTab() {
      return Number(this.$route.params.subsectionId)
    },
    courseTopic() {
      if (this.content) {
        return this.isTestViewMode || this.isTestingMode || this.isTestReviewMode
          ? this.content.topics[this.content.topics.length - 1]
          : this.content.topics.find((p) => p.sections.find((s) => s.id
            === Number(this.$route.params.sectionId)))
      }
      return { title: '', position: 0 }
    },
    section() {
      if (this.content) {
        return this.isTestViewMode
          ? this.courseTopic.sections.find((s) => s.id
            === Number(this.editedTestId))
          : this.courseTopic.sections.find((s) => s.id
            === Number(this.$route.params.sectionId))
      }

      return { title: '' }
    },
    testSubsectionsIds() {
      return this.courseContent.topics[this.courseContent.topics.length - 1].sections
        .find((s) => s.id === Number(this.editedTestId)).subSections
        .map((ss) => ss.id)
    }
  },
  methods: {
    ...mapActions({
      updateUpdater: 'contentManager/updateUpdater'
    }),
    ...mapMutations({
      updateContentSavedStatus: 'contentManager/updateContentSavedStatus'
    }),
    onSubsectionMove() {
      this.updateUpdater(this.updater + 1)
      this.updateContentSavedStatus(false)
    },
    checkIsPassedSubsection(subsectionId) {
      return (this.content && this.content.userCourses
        && this.content.userCourses.length && this.content.userCourses[0].progress
        && this.content.userCourses[0].progress
        && (subsectionId in this.content.userCourses[0].progress))
        ? this.content.userCourses[0].progress[subsectionId] : false
    },
    getTooltip(subsection) {
      if (subsection && subsection.type) {
        if (subsection.type.includes('test')) {
          return 'Задание'
        }
        if (subsection.type.includes('info')) {
          return 'Информация'
        }
      }
      return ''
    },
    getIconClass(subsection) {
      const classes = { fas: true, 'fa-lg': true }
      if (this.isTestCreationMode) {
        if (this.testSubsectionsIds.includes(subsection.id)) {
          classes['fa-check'] = true
        } else {
          classes['fa-question'] = true
        }
      } else {
        switch (subsection.type) {
          case 'text-info':
            classes['fa-book'] = true
            break
          case 'video-info':
            classes['fa-film'] = true
            break
          case 'flash-info':
            classes['fa-wrench'] = true
            break
          case 'model-info':
            classes['fa-cubes'] = true
            break
          case undefined:
            classes['fa-spinner'] = true
            break
          default:
            if (subsection.type.includes('test')) {
              if (subsection.isSelfTest) {
                classes['fa-pencil-ruler'] = true
              } else {
                classes['fa-pencil-alt'] = true
              }
            } else {
              classes['fa-spinner'] = true
            }
        }
      }

      return classes
    },
    getClasses(id, isPassed) {
      if (this.isTestingMode) {
        return {
          'm-1': true,
          'b-tabs-subsections__li': true,
          'b-tabs-subsections__li-not-passed': (id !== this.selectedTab) && !this.isSolved(id),
          'b-tabs-subsections__li-passed-selected': (id === this.selectedTab) && this.isSolved(id),
          'b-tabs-subsections__li-passed': (id !== this.selectedTab) && this.isSolved(id),
          'b-tabs-subsections__li-not-passed-selected': (id === this.selectedTab) && !this.isSolved(id)
        }
      }
      if (this.isTestReviewMode) {
        return {
          'm-1': true,
          'b-tabs-subsections__li': true,
          'b-tabs-subsections__li-student-not-passed': (id !== this.selectedTab) && !this.isSolvedByStudent(id),
          'b-tabs-subsections__li-passed-selected': (id === this.selectedTab) && this.isSolvedByStudent(id),
          'b-tabs-subsections__li-passed': (id !== this.selectedTab) && this.isSolvedByStudent(id),
          'b-tabs-subsections__li-student-not-passed-selected': (id === this.selectedTab) && !this.isSolvedByStudent(id)
        }
      }
      if (this.isEditMode) {
        return {
          'm-1': true,
          'b-tabs-subsections__li': true,
          'b-tabs-subsections__li-draggable': true,
          'b-tabs-subsections__li-not-passed-selected': (id === this.selectedTab)
        }
      }
      return {
        'm-1': true,
        'b-tabs-subsections__li': true,
        'b-tabs-subsections__li-not-passed': (id !== this.selectedTab) && !isPassed,
        'b-tabs-subsections__li-passed-selected': (id === this.selectedTab) && isPassed,
        'b-tabs-subsections__li-passed': (id !== this.selectedTab) && isPassed,
        'b-tabs-subsections__li-not-passed-selected': (id === this.selectedTab) && !isPassed
      }
    },
    getStyle(index) {
      if (this.section.subSections[index].id === this.selectedTab) {
        return {}
      }
      const len = this.section.subSections.length
      const pos = this.section.subSections[index].position
      const l = parseInt(80 - ((len - pos) / len) * 40, 10)
      return {
        'background-color': `hsl(203, 100%, ${l}%)`,
        border: `1px solid hsl(203, 100%, ${l}%)`
      }
    },
    goToOtherSubsection(id) {
      if (id !== this.selectedTab && id) {
        this.$router.push(`${this.$_getCourseRoutePrefix(this.$route.path)}${
          this.$route.params.courseBookId}/section/${
          this.$route.params.sectionId}/subsection/${id}`)
      }
    },
    isSolved(id) {
      return this.solvedTasks.map((t) => Number(t.split('_')[2])).includes(id)
    },
    isSolvedByStudent(id) {
      return this.solvedByStudent
        .find((sbs) => Number(sbs[0])
          === this.test.subSections
            .find((ss) => ss.id === id).task.id)[1].isCorrect
    }
  }
}
</script>

<style>
.b-tabs-subsections__li{
  display: inline-block;
}
.b-tabs-subsections__li-draggable{
  border-radius: 10px !important;
}
.b-tabs-subsections__li-draggable a{
  cursor: grab;
  color: white;
  border-radius: 10px !important;
}
.b-tabs-subsections__li-not-passed a{
  background-color: #0078c1;
  border: 1px solid #0078c1;
  color: white;
  border-radius: 10px !important;
}
.b-tabs-subsections__li-student-not-passed a{
  background-color: rgb(218, 70, 70);
  border: 1px solid rgb(218, 70, 70);
  color: white;
  border-radius: 10px !important;
}
.b-tabs-subsections__li-passed-selected a{
  background-color: white;
  border: 1px solid green;
  color: green;
  border-radius: 10px !important;
}
.b-tabs-subsections__li-passed a{
  background-color: green;
  border: 1px solid green;
  color: white;
  border-radius: 10px !important;
}
.b-tabs-subsections__li-not-passed-selected a{
  background-color: white;
  border: 1px solid #0078c1;
  color: #0078c1;
  border-radius: 10px !important;
}
.b-tabs-subsections__li-student-not-passed-selected a{
  background-color: white;
  border: 1px solid rgb(218, 70, 70);
  color: rgb(218, 70, 70);
  border-radius: 10px !important;
}

</style>
